import { create } from 'zustand';

/**
 * Course-predictor vector setting (spec 02). A line ahead of own-ship whose
 * length is the distance covered in `minutes` at current speed — a look-ahead
 * for "am I steering into that skerry?". Off by default; device-local.
 */
export type PredictorMode = 'off' | 'm1' | 'm3' | 'm6';

const KEY = 'los.predictor';

export const PREDICTOR_MINUTES: Record<PredictorMode, number> = {
  off: 0,
  m1: 1,
  m3: 3,
  m6: 6,
};

function loadMode(): PredictorMode {
  try {
    const v = localStorage.getItem(KEY);
    if (v === 'off' || v === 'm1' || v === 'm3' || v === 'm6') return v;
  } catch {
    /* private mode */
  }
  return 'off';
}

interface PredictorState {
  mode: PredictorMode;
  setMode: (mode: PredictorMode) => void;
}

export const usePredictorStore = create<PredictorState>((set) => ({
  mode: loadMode(),
  setMode: (mode) => {
    try {
      localStorage.setItem(KEY, mode);
    } catch {
      /* ignore */
    }
    set({ mode });
  },
}));
